module.exports = __webpack_public_path__ + "static/media/icn-attachment.175ca60f.svg";